import { render, staticRenderFns } from "./effect.vue?vue&type=template&id=6e063191&scoped=true"
import script from "./effect.vue?vue&type=script&lang=ts"
export * from "./effect.vue?vue&type=script&lang=ts"
import style0 from "./effect.vue?vue&type=style&index=0&id=6e063191&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e063191",
  null
  
)

export default component.exports